// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.future-order-confirm {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: #fff;
  padding: 40px 24px 24px;
}

.close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.alert-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(var(--ion-color-primary-rgb), 0.1);
  color: var(--ion-color-primary);
  margin-bottom: 16px;
}

.title {
  font-family: AppFontBold, sans-serif;
  font-size: 20px;
  line-height: 25px;
  color: #000;
  margin: 0;
  text-wrap: balance;
}

.description {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  line-height: 18px;
  color: #54504c;
  margin: 8px 0 0;
  text-wrap: pretty;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-top: 24px;
}
.action-buttons ion-button {
  width: 100%;
  min-height: 46px;
  height: 46px;
  font-size: 14px;
  --padding-start: 12px;
  --padding-end: 12px;
}
.action-buttons .change-btn {
  --background: transparent;
  --background-hover: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --border-width: 1.5px;
  --border-style: solid;
  --border-color: var(--ion-color-primary);
  --color: var(--ion-color-primary);
  color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/future-order-confirm-modal/future-order-confirm-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AADD;;AAIA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AADD;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,+BAAA;EACA,mBAAA;AADD;;AAIA;EACC,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AADD;;AAIA;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AADD;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AADD;AAGC;EACC,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;AADF;AAIC;EACC,yBAAA;EACA,+BAAA;EACA,mCAAA;EACA,iCAAA;EACA,qBAAA;EACA,qBAAA;EACA,wCAAA;EACA,iCAAA;EAGA,+BAAA;AAJF","sourcesContent":["@import '../../../theme/mixins';\n\n.future-order-confirm {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\ttext-align: center;\n\tbackground: #fff;\n\tpadding: 40px 24px 24px;\n}\n\n.close {\n\tposition: absolute;\n\ttop: 14px;\n\tright: 14px;\n\twidth: 16px;\n\theight: 16px;\n\tcursor: pointer;\n}\n\n.alert-badge {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 44px;\n\theight: 44px;\n\tborder-radius: 50%;\n\tbackground: rgba(var(--ion-color-primary-rgb), 0.1);\n\tcolor: var(--ion-color-primary);\n\tmargin-bottom: 16px;\n}\n\n.title {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 20px;\n\tline-height: 25px;\n\tcolor: #000;\n\tmargin: 0;\n\ttext-wrap: balance;\n}\n\n.description {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 14px;\n\tline-height: 18px;\n\tcolor: #54504c;\n\tmargin: 8px 0 0;\n\ttext-wrap: pretty;\n}\n\n.action-buttons {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\twidth: 100%;\n\tmargin-top: 24px;\n\n\tion-button {\n\t\twidth: 100%;\n\t\tmin-height: 46px;\n\t\theight: 46px;\n\t\tfont-size: 14px;\n\t\t--padding-start: 12px;\n\t\t--padding-end: 12px;\n\t}\n\n\t.change-btn {\n\t\t--background: transparent;\n\t\t--background-hover: transparent;\n\t\t--background-activated: transparent;\n\t\t--background-focused: transparent;\n\t\t--border-width: 1.5px;\n\t\t--border-style: solid;\n\t\t--border-color: var(--ion-color-primary);\n\t\t--color: var(--ion-color-primary);\n\t\t// global.scss sets a plain `color: white` on every ion-button host, which the shadow\n\t\t// .button-native inherits — so the outline label needs the plain property, not just --color.\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
